'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSimulated = undefined;

var _isStatus = require('./isStatus');

var _messageStatusTypes = require('../constants/messageStatusTypes');

var isSimulated = exports.isSimulated = (0, _isStatus.isStatus)(_messageStatusTypes.SIMULATED);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isSimulated.js
// module id = 450
// module chunks = 2 3